import InventoryService from '@/services/inventory'
import OrdersService from '@/services/orders'
import { useToast } from 'vue-toast-notification'
import i18n from '../i18n'
import router from '@/router'

const toast = (status, message) => {
    useToast()[status](i18n.global.t(message), {
        position: 'top-right',
        duration: 5000,
        pauseOnHover: true,
        dismissible: true,
        closeButton: 'button',
        icon: true,
        iconPack: 'fontawesome',
    })
}

const serviceMap = {
    inventory: InventoryService,
    orders: OrdersService,
    'orders-products': OrdersService,
}

const filterOptions = {
    productCostRange: {
        min: null,
        max: null,
    },
    minimumProfitAmountRange: {
        min: null,
        max: null,
    },
    profitAmountRange: {
        min: null,
        max: null,
    },
    myPriceDifferenceWithLowestSeller: {
        min: null,
        max: null,
    },
    generalNumberOfVendors: {
        min: null,
        max: null,
    },
    profitRateRange: {
        min: null,
        max: null,
    },
    myPriceDifferenceWithBuyBoxSeller: {
        min: null,
        max: null,
    },
    pieceRangeToFitInTheParcel: {
        min: null,
        max: null,
    },
    orderStatus: [],
    quantityOrder: {
        min: null,
        max: null,
    },
    salesPriceRange: {
        min: null,
        max: null,
    },
    myProfitDifferenceWithLowestSeller: {
        min: null,
        max: null,
    },
    productScoreRange: {
        min: null,
        max: null,
    },
    productStockNumberRange: {
        min: null,
        max: null,
    },
    myProfitDifferenceWithBuyBoxSeller: {
        min: null,
        max: null,
    },
    dailySalesQuantityRange: {
        min: null,
        max: null,
    },
    numberOfVariations: {
        min: null,
        max: null,
    },
    salesRankRange: {
        min: null,
        max: null,
    },
    totalSalesQuantityRange: {
        min: null,
        max: null,
    },
    returnCount: {
        min: null,
        max: null,
    },
    returnType: [],
    noVariation: null,
    duplicateProduct: null,
    restrictedBrand: null,
    activeProducts: null,
    noSuitableSeller: null,
    restrictedProductList: null,
    inActiveProducts: null,
    category: null,
    restrictedBrandList: null,
    noCostProducts: null,
    replacementOrders: null,
    lossOrders: null,
    productsWhichIAmSoleSeller: null,
    operator: 'and',
}

const state = {
    list: {
        current_page: 1,
        data: [],
        item_count: 0,
        last_page: 1,
        links: [],
        per_page: 50,
        total: 0,
    },
    columns: [
        {
            key: 'image',
            visible: true,
            style: 'max-width: 75px; text-align: center',
            sortable: false,
        },
        {
            key: 'productInfo',
            visible: true,
            style: 'max-width: 260px',
            sortable: false,
        },
        {
            key: 'total_quantity',
            visible: true,
            style: 'text-align: center;',
            sortable: true,
        },
        {
            key: 'price',
            visible: true,
            sortable: true,
        },
        {
            key: 'category',
            visible: false,
            style: 'max-width: 100px',
            sortable: false,
        },
        /* {
                  key: 'brand',
                  visible: false,
                  sortable: false,
              }, */
        {
            key: 'bsr',
            visible: true,
            sortable: true,
        },
        /* {
                  key: 'rating',
                  visible: false,
                  sortable: false,
              }, */
        {
            key: 'sales_count',
            visible: false,
            sortable: true,
        },
        {
            key: 'cost_of_goods',
            visible: true,
            style: 'max-width: 150px;',
            sortable: true,
        },
        {
            key: 'total_fee',
            visible: false,
            sortable: true,
        },
        {
            key: 'sales_price',
            visible: true,
            sortable: true,
        },
        {
            key: 'profit_margin',
            visible: false,
            sortable: true,
        },
        {
            key: 'profit',
            visible: true,
            sortable: true,
        },
        {
            key: 'status',
            visible: true,
            style: 'width: 80px; text-align: center',
            sortable: false,
        },
    ],
    filters: [],
    selectedFilterCard: {
        id: null,
        filter_name: null,
        options: null,
        product_count: null,
    },
    filterParams: {
        page: 1,
        search: null,
        perPage: 50,
        filter_id: null,
        sortBy: null,
    },
    filterOptions: structuredClone(filterOptions),
    filterOptionsClone: structuredClone(filterOptions),
    selectedRows: [],
    categories: [],
    detail: {},
    offers: {},
    supply: {},
    pastOrders: {},
    keepa: {},
    calculate: {},
    currentCalculate: {},
    stats: {},
    outOfStock: {},
    bestSellers: [],
    withoutCog: {},
    isLoadingList: false,
    isApplyFiltering: false,
    locationStats: {},
    salesVelocity: {},
}

const mutations = {
    SET_LIST(state, payload) {
        state.list = payload
    },
    SET_COLUMNS(state, payload) {
        state.columns = payload
    },
    SET_COLUMN_TOGGLE(state, index) {
        state.columns[index].visible = !state.columns[index].visible
    },
    SET_FILTER_PARAMS(state, { key, value }) {
        state.selectedRows = []
        state.filterParams[key] = value
    },
    SET_SELECTED_ROW(state, id) {
        const index = state.selectedRows.indexOf(id)
        if (index > -1) {
            state.selectedRows.splice(index, 1)
        } else {
            state.selectedRows.push(id)
        }
    },
    SET_SELECTED_ALL_ROWS(state) {
        if (state.selectedRows.length === state.list.data.length) {
            state.selectedRows = []
            return
        }
        state.selectedRows = state.list.data.map((item) => item.id)
    },
    SET_RESET_ALL_ROWS(state) {
        state.selectedRows = []
    },
    SET_FILTERS(state, payload) {
        state.filters = payload
    },
    SET_SELECTED_FILTER_CARD(state, payload) {
        state.selectedFilterCard = payload
    },
    SET_RESET_SELECTED_FILTER_CARD(state, payload) {
        state.selectedFilterCard = { id: null, filter_name: null, options: null, product_count: null }
        state.filterParams.filter_id = null
    },
    SET_FILTER_OPTIONS(state, { key, value }) {
        state.filterOptions[key] = value
    },
    SET_FILTER_OPTIONS_MASS(state, payload) {
        state.filterOptions = Object.keys(filterOptions).reduce((acc, key) => {
            // eslint-disable-next-line no-prototype-builtins
            acc[key] = payload.hasOwnProperty(key) ? payload[key] : filterOptions[key]
            return acc
        }, {})
    },
    SET_RESET_FILTER_OPTIONS(state) {
        state.filterOptions = structuredClone(filterOptions)
    },
    SET_CATEGORIES(state, payload) {
        state.categories = payload
    },
    SET_DETAIL(state, payload) {
        state.detail = payload
    },
    SET_OFFERS(state, payload) {
        state.offers = payload
    },
    SET_SUPPLY(state, payload) {
        state.supply = payload
    },
    SET_PAST_ORDERS(state, payload) {
        state.pastOrders = payload
    },
    SET_KEEPA(state, payload) {
        state.keepa = payload
    },
    SET_CALCULATE(state, payload) {
        state.calculate = payload
    },
    SET_CURRENT_CALCULATE(state, payload) {
        state.currentCalculate = payload
    },
    SET_STATS(state, payload) {
        state.stats = payload
    },
    SET_OUT_OF_STOCK(state, payload) {
        state.outOfStock = payload
    },
    SET_BEST_SELLERS(state, payload) {
        state.bestSellers = payload
    },
    SET_WITHOUT_COG(state, payload) {
        state.withoutCog = payload
    },
    SET_LOADING_LIST(state, payload) {
        state.isLoadingList = payload
    },
    SET_IS_APPLY_FILTERING(state, payload) {
        state.isApplyFiltering = payload
    },
    SET_LOCATION_STATS(state, payload) {
        state.locationStats = payload
    },
    SET_SALES_VELOCITY(state, payload) {
        state.salesVelocity = payload
    },
}

const actions = {
    getInventoryList({ state, commit }, payload) {
        const { loading = true } = payload || {}
        if (loading) {
            commit('SET_LOADING_LIST', true)
        }
        return new Promise((resolve, reject) => {
            InventoryService.getInventoryList(state.filterParams)
                .then((response) => {
                    resolve(response)
                    const { data } = response
                    data.data = data.data.map((item) => ({ ...item, isCogInputloading: false }))
                    commit('SET_LIST', data)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    commit('SET_LOADING_LIST', false)
                })
        })
    },
    downloadLabels({ commit, rootState }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.downloadLabels(payload)
                .then((response) => {
                    resolve(response)
                    if (response.data?.downloadUrl) {
                        const a = document.createElement('a')
                        a.href = response.data.downloadUrl
                        a.download = `itemLabel-${crypto.randomUUID()}.pdf`
                        document.body.appendChild(a)
                        a.click()
                        document.body.removeChild(a)
                        setTimeout(() => {
                            toast('success', 'views.inventory.modals.downloadLabels.toast.success')
                        }, 1000)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getExpenses({ commit, rootState }, id) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getExpenses(id)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    createExpenses({ commit, dispatch }, { id, payload }) {
        return new Promise((resolve, reject) => {
            InventoryService.createExpenses(id, payload)
                .then((response) => {
                    resolve(response)
                    if (response.data.success) {
                        toast('success', 'views.inventory.modals.expenses.toast.success')
                        dispatch('getInventoryList', { loading: false })
                    } else {
                        toast('error', 'views.inventory.modals.expenses.toast.error')
                    }
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventory.modals.expenses.toast.error')
                })
        })
    },
    bulkCostCreate({ commit, dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            InventoryService.bulkCostCreate(payload)
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    createFilter({ commit, dispatch, rootState }, payload) {
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            selectedService
                .createFilter(payload)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.newFilter.toast.create.success')
                    dispatch('getFilters')
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventory.modals.newFilter.toast.create.error')
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    updateFilter({ commit, dispatch, rootState }, { id, payload }) {
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            selectedService
                .updateFilter(id, payload)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.savedFilters.toast.edit.success')
                    dispatch('getFilters')
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventory.modals.savedFilters.toast.edit.error')
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    deleteFilter({ commit, dispatch, rootState }, id) {
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            selectedService
                .deleteFilter(id)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.savedFilters.toast.delete.success')
                    dispatch('getFilters')
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventory.modals.savedFilters.toast.delete.error')
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getFilters({ commit, rootState }) {
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            selectedService
                .getFilters()
                .then((response) => {
                    resolve(response)
                    commit(
                        'SET_FILTERS',
                        response.data.map((item) => ({ ...item, filter_name_clone: item.filter_name, editable: false })),
                    )
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getFilter({ state, commit }, id) {
        commit('SET_IS_APPLY_FILTERING', false)
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        return new Promise((resolve, reject) => {
            selectedService
                .getFilter(id)
                .then((response) => {
                    resolve(response)
                    commit('SET_SELECTED_FILTER_CARD', response.data)
                    commit('SET_FILTER_OPTIONS_MASS', response.data?.options ? response.data?.options : state.filterOptionsClone)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    applyFilter({ commit, rootState }, { payload, params }) {
        commit('SET_IS_APPLY_FILTERING', true)
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            selectedService
                .applyFilter(
                    {
                        ...payload,
                        type,
                    },
                    params,
                )
                .then((response) => {
                    resolve(response.data)
                    commit('SET_FILTER_OPTIONS_MASS', payload.options)
                    const { data } = response
                    if (type === 'inventory') {
                        data.data = data.data.map((item) => ({ ...item, isCogInputloading: false }))
                        commit('SET_LIST', data)
                    }
                    if (type === 'orders') {
                        commit('orders/SET_LIST', data, { root: true })
                    }
                    if (type === 'orders-products') {
                        commit('products/SET_LIST', data, { root: true })
                    }
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    filterSort({ commit, dispatch, rootState }, payload) {
        const type = router.currentRoute.value.name
        const selectedService = serviceMap[type]
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            selectedService
                .filterSort(payload)
                .then((response) => {
                    resolve(response)
                    dispatch('getFilters')
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getCategories({ commit, rootState }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getCategories()
                .then((response) => {
                    resolve(response)
                    commit('SET_CATEGORIES', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getDetail({ commit }) {
        return new Promise((resolve, reject) => {
            InventoryService.getDetail(state.detail.id)
                .then((response) => {
                    resolve(response)
                    commit('SET_DETAIL', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    deleteProduct({ state, commit, rootState, dispatch }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.deleteProduct(state.detail.id)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.productDetail.detail.toast.deleteProduct.success')
                    dispatch('getInventoryList')
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    addToRestrictedProduct({ state, commit, rootState, dispatch }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.addToRestrictedProduct(state.detail.id)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.productDetail.detail.toast.addToRestrictedProduct.success')
                    dispatch('getDetail', state.detail.id)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    removeRestrictedProduct({ state, commit, rootState, dispatch }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.removeRestrictedProduct(state.detail.id)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.productDetail.detail.toast.addToRestrictedProduct.delete')
                    dispatch('getDetail', state.detail.id)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    addToRestrictedBrand({ state, commit, rootState, dispatch }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.addToRestrictedBrand(state.detail.id)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.productDetail.detail.toast.addToRestrictedBrand.success')
                    dispatch('getDetail', state.detail.id)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    removeRestrictedBrand({ state, commit, rootState, dispatch }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.removeRestrictedBrand(state.detail.id)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.productDetail.detail.toast.addToRestrictedBrand.delete')
                    dispatch('getDetail', state.detail.id)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    variationScan({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.variationScan(state.detail.id, payload)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.productDetail.detail.toast.variationScan.success')
                    dispatch('getDetail', state.detail.id)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getOffers({ state, commit }) {
        return new Promise((resolve, reject) => {
            InventoryService.getOffers(state.detail.id)
                .then((response) => {
                    resolve(response)
                    commit('SET_OFFERS', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getSupply({ state, commit }) {
        return new Promise((resolve, reject) => {
            InventoryService.getSupply(state.detail.id)
                .then((response) => {
                    resolve(response)
                    const data = response.data
                    if (data.supplies) {
                        data.supplies = response.data.supplies.map((supply) => ({
                            value: supply,
                            value_clone: supply,
                            editable: false,
                        }))
                    }

                    commit('SET_SUPPLY', data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    addSupply({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.addSupply(state.detail.id, payload)
                .then((response) => {
                    resolve(response)
                    dispatch('getSupply')
                    toast('success', 'views.inventory.modals.productDetail.supplyAndNotes.toast.addUrl.success')
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    editSupply({ state, commit, rootState, dispatch }, { index, payload }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.editSupply(state.detail.id, index, payload)
                .then((response) => {
                    resolve(response)
                    dispatch('getSupply')
                    toast('success', 'views.inventory.modals.productDetail.supplyAndNotes.toast.addUrl.success')
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    deleteSupply({ state, commit, rootState, dispatch }, { index }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.deleteSupply(state.detail.id, index)
                .then((response) => {
                    resolve(response)
                    dispatch('getSupply')
                    toast('success', 'views.inventory.modals.productDetail.supplyAndNotes.toast.deleteUrl.success')
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    addNote({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.addNote(state.detail.id, payload)
                .then((response) => {
                    resolve(response)
                    dispatch('getSupply')
                    toast('success', 'views.inventory.modals.productDetail.supplyAndNotes.toast.addNote.success')
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getPastOrders({ state, commit }, params) {
        return new Promise((resolve, reject) => {
            InventoryService.getPastOrders(state.detail.id, params)
                .then((response) => {
                    resolve(response)
                    commit('SET_PAST_ORDERS', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getKeepa({ state, commit }, params) {
        return new Promise((resolve, reject) => {
            InventoryService.getKeepa(state.detail.id, params)
                .then((response) => {
                    resolve(response)
                    commit('SET_KEEPA', response.data.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    setCalculate({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            InventoryService.setCalculate(state.detail.id, payload)
                .then((response) => {
                    resolve(response)
                    commit('SET_CALCULATE', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getCurrentCalculate({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getCurrentCalculate(state.detail.id, payload)
                .then((response) => {
                    resolve(response)
                    commit('SET_CURRENT_CALCULATE', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getStats({ state, commit, rootState, dispatch }, date) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getStats(date)
                .then((response) => {
                    resolve(response)
                    commit('SET_STATS', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getOutOfStock({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            InventoryService.getOutOfStock(payload)
                .then((response) => {
                    resolve(response)
                    const newData = response.data

                    if (state.outOfStock?.data?.length > 0) {
                        newData.data = [...state.outOfStock.data, ...newData.data]
                    }
                    commit('SET_OUT_OF_STOCK', newData)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getBestSellers({ state, commit, rootState, dispatch }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getBestSellers()
                .then((response) => {
                    resolve(response)
                    commit('SET_BEST_SELLERS', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getWithoutCog({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            InventoryService.getWithoutCog(payload)
                .then((response) => {
                    resolve(response)
                    const newData = response.data

                    if (state.withoutCog?.data?.length > 0) {
                        newData.data = [...state.withoutCog.data, ...newData.data]
                    }

                    commit('SET_WITHOUT_COG', newData)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    addToInventory({ dispatch }, payload) {
        return new Promise((resolve, reject) => {
            InventoryService.addToInventory(payload)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.modals.addProduct.toast.success')
                    dispatch('getInventoryList')
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventory.modals.addProduct.toast.error')
                })
        })
    },
    sendToScan({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.sendToScan(payload)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventoryStatus.outOfStock.toast.success')
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventoryStatus.outOfStock.toast.error')
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    removeProducts({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.removeProducts(payload)
                .then((response) => {
                    resolve(response)
                    toast('success', 'views.inventory.removeProduct.toast.success')
                    dispatch('getInventoryList')
                })
                .catch((error) => {
                    reject(error)
                    toast('error', 'views.inventory.removeProduct.toast.error')
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getLocationStats({ state, commit, rootState, dispatch }, { payload, isFromLoadMore = false }) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getLocationStats(payload)
                .then((response) => {
                    resolve(response)
                    const newData = response.data

                    if (state.locationStats?.data?.length > 0 && isFromLoadMore) {
                        newData.data = [...state.locationStats.data, ...newData.data]
                    }
                    commit('SET_LOCATION_STATS', newData)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
    getSalesVelocity({ state, commit, rootState, dispatch }, payload) {
        rootState.loading.status = true
        return new Promise((resolve, reject) => {
            InventoryService.getSalesVelocity(payload)
                .then((response) => {
                    resolve(response)
                    const newData = response.data

                    if (state.salesVelocity?.data?.length > 0) {
                        newData.data = [...state.salesVelocity.data, ...newData.data]
                    }
                    commit('SET_SALES_VELOCITY', newData)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    rootState.loading.status = false
                })
        })
    },
}

const getters = {
    totalPages: (state) => {
        return Math.ceil(state.list.total / state.filterParams.perPage) || 1
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
